import styled, { css } from 'styled-components'

import { colors } from 'app/theme/colors'

export { SubBlockContent as Content } from 'app/components/shared/dashboardSummaryStyles'

const breakpoint = '1024px'

export const Body = styled.div`
  height: 100%;

  .MuiDivider-root {
    width: 100%;
  }
`

export const ColumnFlexStart = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 4px;
`

export const ColumnFlexGap = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  gap: 8px;
`

export const RowFlexStart = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  flex-direction: row;
  gap: 4px;
`

export const RowFlexSpace = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
  grid-gap: 8px;
  row-gap:16px;
`
export const Heading = styled.div`
  font-family: AvenirDemi;
  font-size: 24px;
  line-height: 32px;
`

export const InfoBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const Coins = styled.div`
  font-size: 16px;
  font-family: AvenirMedium;
  line-height: 20px;
  color: ${colors.black};
  display: flex;
  align-items: center;
  gap: 4px;
`

export const CoinImg = styled.div`
  height: 12px;
  width: 12px;
  background: ${colors.ohOrange};
  border-radius: 32px;
`
